export var IntegType;
(function (IntegType) {
    IntegType["INTEGRATION_TYPE_UNSPECIFIED"] = "UNSPECIFIED";
    IntegType["INTEGRATION_TYPE_REDSHIFT"] = "REDSHIFT";
    IntegType["INTEGRATION_TYPE_BIGQUERY"] = "BIGQUERY";
    IntegType["INTEGRATION_TYPE_SNOWFLAKE"] = "SNOWFLAKE";
    IntegType["INTEGRATION_TYPE_DATABRICKS"] = "DATABRICKS";
    IntegType["INTEGRATION_TYPE_MICROSOFT_FABRIC"] = "MICROSOFT_FABRIC";
})(IntegType || (IntegType = {}));
